import { render, staticRenderFns } from "./mobile-register-entrance.vue?vue&type=template&id=196182ac&scoped=true&"
import script from "./mobile-register-entrance.vue?vue&type=script&lang=js&"
export * from "./mobile-register-entrance.vue?vue&type=script&lang=js&"
import style0 from "./mobile-register-entrance.vue?vue&type=style&index=0&id=196182ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196182ac",
  null
  
)

export default component.exports